import { useState, useEffect } from "react";
import { Btn, Card, Inp, Lbl, Slct, ConfirmModal } from "../ui";
import { sigteApiFetch, sigteApiFetchChecked } from "./sigteUtils";

var SIGTE_BRAND = "#0F2C70";
var BLANK = {interno:"",fabricante_num:"",marca_id:"",modelo:"",capacidad:"",velocidad:"",anio:"",tipo_id:"",estado_id:""};

export function SigteEquipos(p) {
  var edificio = p.edificio;
  var [equipos,setEquipos]=useState([]);
  var [catalogos,setCatalogos]=useState([]);
  var [loading,setLoading]=useState(true);
  var [view,setView]=useState("list");
  var [editing,setEditing]=useState(null);
  var [form,setForm]=useState(BLANK);
  var [err,setErr]=useState("");
  var [confirmData,setConfirmData]=useState(null);

  function load(){
    Promise.all([
      sigteApiFetch("/equipos?edificio_id="+edificio.id).then(function(r){return r.json();}),
      sigteApiFetch("/catalogos").then(function(r){return r.json();}),
    ]).then(function(res){
      setEquipos(res[0].equipos||[]);
      setCatalogos(res[1].catalogos||[]);
      setLoading(false);
    });
  }
  useEffect(load,[edificio.id]);

  function catOpts(categoria, currentId){
    return catalogos.filter(function(c){ return c.categoria===categoria && (c.activo || c.id===currentId); });
  }
  function catLabel(id){
    var c = catalogos.find(function(x){return x.id===id;});
    return c ? c.valor : "?";
  }

  function setF(k,v){ setForm(function(f){return Object.assign({},f,{[k]:v});}); }
  function ask(msg,fn){ setConfirmData({msg:msg,fn:fn}); }

  function startNew(){ setEditing(null); setForm(BLANK); setErr(""); setView("edit"); }
  function startEdit(eq){
    setEditing(eq);
    setForm(Object.assign({},BLANK,eq,{anio:eq.anio||""}));
    setErr(""); setView("edit");
  }

  async function save(){
    if(!form.marca_id||!form.tipo_id||!form.estado_id){setErr("Marca, tipo y estado son requeridos.");return;}
    var path = editing ? "/equipos/"+editing.id : "/equipos";
    var method = editing ? "PUT" : "POST";
    var body = Object.assign({},form,{
      marca_id: parseInt(form.marca_id,10),
      tipo_id: parseInt(form.tipo_id,10),
      estado_id: parseInt(form.estado_id,10),
      anio: form.anio ? parseInt(form.anio,10) : null,
    });
    if(!editing) body.edificio_id = edificio.id;
    try {
      await sigteApiFetchChecked(path,{method:method,body:JSON.stringify(body)});
      setView("list"); load();
    } catch(e) {
      setErr(e.message);
    }
  }

  function del(eq){
    ask('Eliminar el equipo "'+(eq.interno||eq.modelo||eq.id)+'"?', async function(){
      try {
        await sigteApiFetchChecked("/equipos/"+eq.id,{method:"DELETE"});
        load();
      } catch(e) {
        setErr(e.message);
      }
    });
  }

  if(loading) return <p style={{color:"#64748b",fontSize:14}}>Cargando...</p>;

  return (
    <div>
      <ConfirmModal data={confirmData} onCancel={function(){setConfirmData(null);}} onConfirm={function(){if(confirmData)confirmData.fn();setConfirmData(null);}}/>
      <button onClick={p.onBack} style={{background:"none",border:"none",color:SIGTE_BRAND,fontSize:12,fontWeight:600,cursor:"pointer",padding:0,marginBottom:14}}>&larr; Volver a Edificios</button>
      {view==="list"?(
        <div>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
            <div><h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:0}}>{"Equipos de "+edificio.nombre}</h1><p style={{color:"#64748b",fontSize:13,marginTop:3}}>{equipos.length+" equipos"}</p></div>
            <Btn onClick={startNew}>+ Nuevo equipo</Btn>
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:12}}>
            {equipos.map(function(eq){
              return (
                <Card key={eq.id} sx={{display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:12}}>
                  <div style={{flex:1}}>
                    <p style={{margin:0,fontWeight:700,fontSize:14,color:"#0f172a"}}>{(eq.interno||"Sin interno")+" · "+catLabel(eq.tipo_id)}</p>
                    <p style={{margin:"2px 0 0",fontSize:12,color:"#64748b"}}>{catLabel(eq.marca_id)+" "+(eq.modelo||"")+" · "+catLabel(eq.estado_id)}</p>
                  </div>
                  <div style={{display:"flex",gap:8}}>
                    <button onClick={function(){startEdit(eq);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #dde3f0",background:"#fff",color:"#374151",fontSize:12,fontWeight:600,cursor:"pointer"}}>Editar</button>
                    <button onClick={function(){del(eq);}} style={{padding:"7px 14px",borderRadius:8,border:"1px solid #fecaca",background:"#fef2f2",color:"#dc2626",fontSize:12,fontWeight:600,cursor:"pointer"}}>Eliminar</button>
                  </div>
                </Card>
              );
            })}
            {equipos.length===0?<p style={{color:"#94a3b8",fontSize:13}}>No hay equipos registrados.</p>:null}
          </div>
        </div>
      ):(
        <div>
          <h1 style={{fontSize:20,fontWeight:800,color:"#0f172a",margin:"0 0 24px"}}>{editing?"Editar equipo":"Nuevo equipo"}</h1>
          <Card>
            {err?<div style={{background:"#fef2f2",border:"1px solid #fecaca",borderRadius:10,padding:"10px 16px",fontSize:13,color:"#dc2626",marginBottom:16}}>{err}</div>:null}
            <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:16,marginBottom:20}}>
              <div><Lbl c="Numero interno"/><Inp value={form.interno} onChange={function(e){setF("interno",e.target.value);}}/></div>
              <div><Lbl c="Numero de fabricante"/><Inp value={form.fabricante_num} onChange={function(e){setF("fabricante_num",e.target.value);}}/></div>
              <div>
                <Lbl c="Marca"/>
                <Slct value={form.marca_id} onChange={function(e){setF("marca_id",e.target.value);}}>
                  <option value="">Selecciona...</option>
                  {catOpts("marca",editing?editing.marca_id:null).map(function(c){return <option key={c.id} value={c.id}>{c.valor}</option>;})}
                </Slct>
              </div>
              <div><Lbl c="Modelo"/><Inp value={form.modelo} onChange={function(e){setF("modelo",e.target.value);}}/></div>
              <div><Lbl c="Capacidad"/><Inp value={form.capacidad} onChange={function(e){setF("capacidad",e.target.value);}}/></div>
              <div><Lbl c="Velocidad"/><Inp value={form.velocidad} onChange={function(e){setF("velocidad",e.target.value);}}/></div>
              <div><Lbl c="Año"/><Inp type="number" value={form.anio} onChange={function(e){setF("anio",e.target.value);}}/></div>
              <div>
                <Lbl c="Tipo"/>
                <Slct value={form.tipo_id} onChange={function(e){setF("tipo_id",e.target.value);}}>
                  <option value="">Selecciona...</option>
                  {catOpts("tipo",editing?editing.tipo_id:null).map(function(c){return <option key={c.id} value={c.id}>{c.valor}</option>;})}
                </Slct>
              </div>
              <div>
                <Lbl c="Estado"/>
                <Slct value={form.estado_id} onChange={function(e){setF("estado_id",e.target.value);}}>
                  <option value="">Selecciona...</option>
                  {catOpts("estado",editing?editing.estado_id:null).map(function(c){return <option key={c.id} value={c.id}>{c.valor}</option>;})}
                </Slct>
              </div>
            </div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={function(){setView("list");}} style={{flex:1,padding:"11px 0",borderRadius:9,border:"1px solid #e2e8f0",background:"#fff",color:"#64748b",fontWeight:600,fontSize:13,cursor:"pointer"}}>Cancelar</button>
              <Btn onClick={save} sx={{flex:2,padding:"11px 0",borderRadius:9,fontSize:14}}>Guardar equipo</Btn>
            </div>
          </Card>
        </div>
      )}
    </div>
  );
}
